import { useLocation } from "react-router-dom";
import Seo from "../Seo/Seo";
import { getSeoForPath } from "../../../constants/seo";

function PageSeo() {
  const { pathname } = useLocation();
  const seo = getSeoForPath(pathname);

  return (
    <Seo
      title={seo.title}
      description={seo.description}
      path={pathname}
      noIndex={seo.noIndex}
    />
  );
}

export default PageSeo;
